export const TRACKING_OBJECTS = {
	GLOBAL_SEARCH_MODAL: 'Global Search Modal',
	TIME_REGISTRATION_MODAL_SEARCH: 'Time Registration Modal Search',
	TIME_REGISTRATION_MODAL_SEARCH_SECONDARY: 'Time Registration Modal Secondary Search',
	TIME_REGISTRATION_MODAL: 'Time Registration Modal',
	CONTEXT_MENU: 'Context Menu',
	LINK_GOOGLE_CALENDAR_ACCOUNT: 'Link Google Calendar Account',
	LINK_OUTLOOK_CALENDAR_ACCOUNT: 'Link Outlook Calendar Account',
};
